/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import gitFileLifeImg from 'assets/images/gitFileLife.png'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Состояния Git</h2>
    <p className={styles.description}>
      Состояния Git это ключевое понятие, которое нужно усвоить. Git имеет три основных состояния, в которых могут
      находиться файлы:
    </p>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <code className={styles.code}>Зафиксированном (committed)</code> - значит, что файл уже сохранён в вашем
        локальном репозитории
      </li>
      <li className={styles.list__item}>
        <code className={styles.code}>Изменённом (modified)</code> - файлы, которые поменялись, но ещё не были
        зафиксированы
      </li>
      <li className={styles.list__item}>
        <code className={styles.code}>Подготовленном (staged)</code> - это изменённые файлы, отмеченные для включения в
        следующий коммит
      </li>
    </ul>
    <img className={styles.img} src={gitFileLifeImg} alt="Git File Life" />
  </section>
))
